module.exports = __webpack_public_path__ + "media/ze.894e3e2e.mp3";